import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.vorlagen-veranstaltungs-typen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenVorlagenVeranstaltungsTypenEffects {

    VorlagenVeranstaltungsTypen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VORLAGEN_VERANSTALTUNGS_TYPEN),
        mergeMap((x: ac.GetVorlagenVeranstaltungsTypenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVorlagenVeranstaltungsTypen().pipe(
                map((result: any) => {
                    return new ac.GetVorlagenVeranstaltungsTypenErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVorlagenVeranstaltungsTypenFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenQueryService);
        }
        return this.service;
    }
}
